import { render, staticRenderFns } from "./SigningIn.vue?vue&type=template&id=80f691b4&scoped=true&"
import script from "./SigningIn.vue?vue&type=script&lang=js&"
export * from "./SigningIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f691b4",
  null
  
)

export default component.exports